import { Routes } from "@angular/router";

import { ApplicationsStepperComponent } from "./common/components/applications-stepper/applications-stepper.component";
import { MainLayoutComponent } from "./layouts/admin-dash-layout/main-layout.component";
import { StudentDashLayoutComponent } from "./layouts/student-dash-layout/student-dash-layout.component";
import { NotFoundAdmComponent } from "./admin-dashboard/not-found/not-found.component";
import { NotFoundComponent } from "./common/not-found/not-found.component";
import { AuthGuard } from "./core/guards/auth.guard";

import { NotFoundStudentComponent } from "./student-dashboard/not-found/not-found.component";
import { CollegeAdminDashLayoutComponent } from "./layouts/college-admin-dash-layout/college-admin-dash-layout.component";
import { ENROLLMENT_SHARED_USER_TYPES } from "./core/constants/shared.access";
import { enrollmentFormRoute } from "./enrollment-form-route";
import { applicationFormRoute } from "./application-form.routes";
import { profileRoute } from "./profile.routes";
import { settingsRoute } from "./settings.routes";
import { sharedRoutes } from "./shared.routes";
import { SessionLockGuard } from "./core/guards/session.guard";
import { enrollmentPaymentPageRoute } from "./enrollmentPaymentPageRoute";
import { HoldRestrictionGuard } from "./core/guards/hold-restriction.guard";
import { CheckoutRoute } from "./checkout.routes";
import { PaymentStatusRoute } from "./payment-status.routes";
import { FacultyDashLayoutComponent } from "./layouts/faculty-dash-layout/faculty-dash-layout.component";
import { featureGuard } from "./core/guards/features.guard";
import { HRAdminDashLayoutComponent } from "./layouts/hr-admin-dash-layout/hr-admin-dash-layout.component";
import { ApplicantAdminDashLayoutComponent } from "./layouts/applicant-admin-dash-layout/applicant-admin-dash-layout.component";
import { VacanciesListComponent } from "./hr-admin-dashboard/internal-vacancies/vacancies-list/vacancies-list.component";
import { ViewVacancyComponent } from "./hr-admin-dashboard/internal-vacancies/view-vacancy/view-vacancy.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "authentication",
    pathMatch: "full",
  },
  {
    path: "public/program-schedules",
    loadComponent: () =>
      import("./common/components/program-schedule/program-schedule.component").then(
        (m) => m.ProgramScheduleComponent,
      ),
  },
  {
    path: "public/job-listings",
    loadComponent: () =>
      import("./common/job-listing/job-listing.component").then(
        (m) => m.JobListingComponent,
      ),
  },
  {
    path: "public/job-listings/details",
    loadComponent: () =>
      import("./common/job-listing/job-details/job-details.component").then(
        (m) => m.JobDetailsComponent,
      ),
  },

  {
    path: "authentication",
    loadComponent: () =>
      import("./authentication/authentication.component").then(
        (m) => m.AuthenticationComponent,
      ),

    children: [
      {
        path: "",
        loadComponent: () =>
          import("./authentication/sign-in/sign-in.component").then(
            (m) => m.SignInComponent,
          ),
      },
      {
        path: "twofactor",
        loadComponent: () =>
          import("./authentication/two-factor/two-factor.component").then(
            (m) => m.TwoFactorComponent,
          ),
      },
      {
        path: "college-lead-form",
        loadComponent: () =>
          import("./authentication/college-lead-form.component/college-lead-form.component.component").then(
            (m) => m.CollegeLeadFormComponent,
          ),
      },

      {
        path: "account-verification-page",
        loadComponent: () =>
          import("./authentication/sign-up/account-verification-page/account-verification-page.component").then(
            (m) => m.AccountVerificationPageComponent,
          ),
      },

      {
        path: "sign-up",
        loadComponent: () =>
          import("./authentication/sign-up/sign-up.component").then(
            (m) => m.SignUpComponent,
          ),
      },
      {
        path: "forgot-password",
        loadComponent: () =>
          import("./authentication/forgot-password/forgot-password.component").then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: "reset-password",
        loadComponent: () =>
          import("./authentication/reset-password/reset-password.component").then(
            (m) => m.ResetPasswordComponent,
          ),
      },
      {
        path: "lock-screen",
        loadComponent: () =>
          import("./authentication/lock-screen/lock-screen.component").then(
            (m) => m.LockScreenComponent,
          ),
      },
      {
        path: "confirm-email",
        loadComponent: () =>
          import("./authentication/confirm-email/confirm-email.component").then(
            (m) => m.ConfirmEmailComponent,
          ),
      },
      {
        path: "logout",
        loadComponent: () =>
          import("./authentication/logout/logout.component").then(
            (m) => m.LogoutComponent,
          ),
      },
      {
        path: "complete-profile",
        canActivate: [AuthGuard, SessionLockGuard],
        loadComponent: () =>
          import("./authentication/college-profile-wizard/college-profile-wizard.component").then(
            (m) => m.CollegeProfileWizardComponent,
          ),
      },
    ],
  },

  {
    path: "faculty-admin-dashboard",
    component: FacultyDashLayoutComponent,
    canActivate: [AuthGuard, SessionLockGuard],
    data: { userTypes: [4] },
    children: [
      { path: "", redirectTo: "welcome", pathMatch: "full" },

      {
        path: "welcome",
        loadComponent: () =>
          import("./faculty-admin-dasboard/welcome/welcome.component").then(
            (m) => m.FacultyAdminWelcomeComponent,
          ),
      },

      //attendance
      {
        path: "attendance-records",
        loadComponent: () =>
          import("./faculty-admin-dasboard/attendance-records/attendance-records.component").then(
            (m) => m.AttendanceRecordsComponent,
          ),
      },

      //record attendance
      {
        path: "record-attendance",
        loadComponent: () =>
          import("./faculty-admin-dasboard/record-attendance/record-attendance.component").then(
            (m) => m.RecordAttendanceComponent,
          ),
      },

      //atttendance report
      {
        path: "attendance-reports",
        loadComponent: () =>
          import("./faculty-admin-dasboard/attendance-reports/attendance-reports.component").then(
            (m) => m.AttendanceReportsComponent,
          ),
      },

      {
        path: "student-management",
        loadComponent: () =>
          import("./faculty-admin-dasboard/student-management/student-management.component").then(
            (m) => m.StudentManagementComponent,
          ),
      },

      {
        path: "student-resources",
        loadComponent: () =>
          import("./faculty-admin-dasboard/student-resources/student-resources.component").then(
            (m) => m.StudentResourcesComponent,
          ),
      },

      ...enrollmentFormRoute,
      ...applicationFormRoute,
      ...profileRoute,
      ...settingsRoute,
      ...sharedRoutes,
      ...enrollmentPaymentPageRoute,

      { path: "**", component: NotFoundAdmComponent },
    ],
  },

  {
    path: "hr-admin-dashboard",
    component: HRAdminDashLayoutComponent,
    canActivate: [AuthGuard, SessionLockGuard],
    data: { userTypes: [9] },
    children: [
      { path: "", redirectTo: "welcome", pathMatch: "full" },

      {
        path: "welcome",
        loadComponent: () =>
          import("./hr-admin-dashboard/welcome/welcome.component").then(
            (m) => m.HrAdminWelcomeComponent,
          ),
      },

      {
        path: "vacancies",
        loadComponent: () =>
          import("./hr-admin-dashboard/internal-vacancies/internal-vacancies.component").then(
            (m) => m.InternalVacanciesComponent,
          ),
      },

      {
        path: "vacancies/:id",
        loadComponent: () =>
          import("./hr-admin-dashboard/internal-vacancies/view-vacancy/view-vacancy.component").then(
            (m) => m.ViewVacancyComponent,
          ),
      },

      {
        path: "department",
        loadComponent: () =>
          import("./hr-admin-dashboard/department/department.component").then(
            (m) => m.DepartmentComponent,
          ),
      },
      {
        path: 'applications',
        loadComponent: () =>
          import('./hr-admin-dashboard/applications-table/applications-table.component')
            .then((m) => m.ApplicationTableComponent)
      },
      {
        path: 'application-view',
        loadComponent: () =>
          import('./hr-admin-dashboard/application-view/application-view.component')
            .then((m) => m.ApplicationViewComponent)
      },
      {
        path: "hired-applicants",
        loadComponent: () =>
          import("./hr-admin-dashboard/hired-applicants/hired-applicants.component").then(
            (m) => m.HiredApplicantsComponent,
          ),
      },

      {
        path: "hired-applicants/view-applicant-page/:id",
        loadComponent: () =>
          import("./hr-admin-dashboard/hired-applicants/view-applicant-page/view-applicant-page.component").then(
            (m) => m.ViewApplicantPageComponent,
          ),
      },

      {
        path: "jobs",
        loadComponent: () =>
          import("./hr-admin-dashboard/jobs/jobs.component").then(
            (m) => m.JobsComponent,
          ),
      },

      { path: "", redirectTo: "/vacancies", pathMatch: "full" },

      { path: "**", component: NotFoundAdmComponent },
    ],
  },

  //add applicant admin dashboard route here
  {
    path: "applicant-admin-dashboard",
    component: ApplicantAdminDashLayoutComponent,
    canActivate: [AuthGuard, SessionLockGuard],
    data: { userTypes: [10] },
    children: [
      { path: "", redirectTo: "welcome", pathMatch: "full" },

      {
        path: "welcome",
        loadComponent: () =>
          import("./applicant-admin-dashboard/welcome/welcome.component").then(
            (m) => m.ApplicantAdminWelcomeComponent,
          ),
      },
      {
        path: "job-listings",
        loadComponent: () =>
          import("./common/job-listing/job-listing.component").then(
            (m) => m.JobListingComponent,
          ),
      },
      {
        path: "job-application-table",
        loadComponent: () =>
          import("./applicant-admin-dashboard/job-application-table/job-application-table.component").then(
            (m) => m.JobApplicationTableComponent,
          ),
      },
      {
        path: "job-application-form",
        loadComponent: () =>
          import("./applicant-admin-dashboard/job-application/job-application.component").then(
            (m) => m.JobApplicationComponent,
          ),
      },
      {
        path: "job-application-view",
        loadComponent: () =>
          import("./applicant-admin-dashboard/job-application-view/job-application-view.component").then(
            (m) => m.JobApplicationViewComponent,
          ),
      },
      {
        path: "job-listings/details",
        loadComponent: () =>
          import("./common/job-listing/job-details/job-details.component").then(
            (m) => m.JobDetailsComponent,
          ),
      },
      { path: "**", component: NotFoundAdmComponent },
    ],
  },

  {
    path: "college-admin-dashboard",
    component: CollegeAdminDashLayoutComponent,
    canActivate: [AuthGuard, SessionLockGuard],
    data: { userTypes: [3, 5, 6, 7, 8] },
    children: [
      { path: "", redirectTo: "welcome", pathMatch: "full" },

      {
        path: "users",
        canActivate: [featureGuard],
        data: { feature: "Users" },
        loadComponent: () =>
          import("./college-admin-dashbaord/users/users.component").then(
            (m) => m.UsersComponent,
          ),
      },

      {
        path: "student-recruitors-performamce",
        canActivate: [featureGuard],
        data: { feature: "Users" },
        loadComponent: () =>
          import("./college-admin-dashbaord/recruiter-performance/recruiter-performance.component").then(
            (m) => m.RecruiterPerformanceComponent,
          ),
      },

      {
        path: "recruiter/:id",
        canActivate: [featureGuard],
        data: { feature: "Users" },
        loadComponent: () =>
          import("./college-admin-dashbaord/recruiter-performance/recruiter-detail/recruiter-detail.component").then(
            (m) => m.RecruiterDetailComponent,
          ),
      },

      {
        path: "scholarship-master",
        canActivate: [featureGuard],
        data: { feature: "Programs" },
        loadComponent: () =>
          import("./college-admin-dashbaord/scholarship-master/scholarship-master.component").then(
            (m) => m.ScholarshipMasterComponent,
          ),
      },

      {
        path: "scholarship-awards",
        canActivate: [featureGuard],
        data: { feature: "Programs" },
        loadComponent: () =>
          import("./college-admin-dashbaord/scholarship-awards/scholarship-awards.component").then(
            (m) => m.ScholarshipAwardsComponent,
          ),
      },

      {
        path: "programs",
        canActivate: [featureGuard],
        data: { feature: "Programs" },
        loadComponent: () =>
          import("./college-admin-dashbaord/programs/programs.component").then(
            (m) => m.ProgramsComponent,
          ),
      },

      {
        path: "fees-components",
        canActivate: [featureGuard],
        data: { feature: "Fee Component" },
        loadComponent: () =>
          import("./college-admin-dashbaord/fee-items/fee-items.component").then(
            (m) => m.FeeItemsComponent,
          ),
      },

      {
        path: "positions",
        canActivate: [featureGuard],
        data: { feature: "Fee Component" },
        loadComponent: () =>
          import("./college-admin-dashbaord/positions-page/positions-page.component").then(
            (m) => m.PositionsPageComponent,
          ),
      },

      // {
      //   path: "programs",
      //   loadComponent: () =>
      //     import("./college-admin-dashbaord/programs/programs.component").then(
      //       (m) => m.ProgramsComponent,
      //     ),
      // },

      {
        path: "college-management",
        loadComponent: () =>
          import("./admin-dashboard/college-management/college-management.component").then(
            (m) => m.CollegeManagementComponent,
          ),
      },

      {
        path: "student-holds",
        canActivate: [featureGuard],
        data: { feature: "Student Holds" },
        loadComponent: () =>
          import("./college-admin-dashbaord/student-holds/student-holds.component").then(
            (m) => m.StudentHoldsComponent,
          ),
      },

      {
        path: "student-holds/:id",
        loadComponent: () =>
          import("./college-admin-dashbaord/student-holds-detail/student-holds-detail.component").then(
            (m) => m.StudentHoldsDetailComponent,
          ),
      },

      {
        path: "enrollment",
        canActivate: [featureGuard],
        data: { feature: "Enrollment" },
        loadComponent: () =>
          import("./college-admin-dashbaord/enrollment/enrollment.component").then(
            (m) => m.EnrollmentComponent,
          ),
      },

      {
        path: "applications",
        canActivate: [featureGuard],
        data: { feature: "Application" },
        loadComponent: () =>
          import("./college-admin-dashbaord/applications/applications.component").then(
            (m) => m.ApplicationsComponent,
          ),
      },
      {
        path: 'documents',
        loadComponent: () =>
          import('./college-admin-dashbaord/documents-repo/documents-repo.component')
            .then((m) => m.DocumentsRepoComponent)
      },
      {
        path: "applications/applications-approval",
        loadComponent: () =>
          import("./college-admin-dashbaord/approve-application-form/approve-application-form.component").then(
            (m) => m.ApproveApplicationFormComponent,
          ),
      },

      {
        path: "complete-profile",
        loadComponent: () =>
          import("./authentication/college-profile-wizard/college-profile-wizard.component").then(
            (m) => m.CollegeProfileWizardComponent,
          ),
      },

      {
        path: "college-leads",
        loadComponent: () =>
          import("./college-admin-dashbaord/college-leads/college-leads.component").then(
            (m) => m.CollegeLeadsComponent,
          ),
      },

      {
        path: "program-dates",
        canActivate: [featureGuard],
        data: { feature: "Program Dates" },
        loadComponent: () =>
          import("./college-admin-dashbaord/program-dates/program-dates.component").then(
            (m) => m.ProgramDatesComponent,
          ),
      },

      {
        path: "welcome",
        loadComponent: () =>
          import("./college-admin-dashbaord/welcome/welcome.component").then(
            (m) => m.CollegeAdminWelcomeComponent,
          ),
      },

      {
        path: "schedules",
        canActivate: [featureGuard],
        data: { feature: "Schedules" },
        loadComponent: () =>
          import("./college-admin-dashbaord/schedule/program-schedule/program-schedule.component").then(
            (m) => m.ProgramScheduleComponent,
          ),
      },
      {
        path: "schedule-type",
        canActivate: [featureGuard],
        data: { feature: "Schedule Type" },
        loadComponent: () =>
          import("./college-admin-dashbaord/schedule/schedules-type/schedules-type.component").then(
            (m) => m.SchedulesTypeComponent,
          ),
      },

      {
        path: "message-templates",
        canActivate: [featureGuard],
        data: { feature: "Message Templates" },
        loadComponent: () =>
          import("./college-admin-dashbaord/message-templates/message-templates.component").then(
            (m) => m.MessageTemplatesComponent,
          ),
      },
      {
        path: "clearance",
        canActivate: [featureGuard],
        data: { feature: "Clearance" },
        loadComponent: () =>
          import("./college-admin-dashbaord/clearance/clearance.component").then(
            (m) => m.ClearanceComponent,
          ),
      },
      {
        path: "clearance/clearance-form",
        canActivate: [featureGuard],
        data: { feature: "Clearance Form" },
        loadComponent: () =>
          import("./college-admin-dashbaord/clearance/clearance-form/clearance-form.component").then(
            (m) => m.ClearanceFormComponent,
          ),
      },
      {
        path: "checklist",
        canActivate: [featureGuard],
        data: { feature: "Checklist" },
        loadComponent: () =>
          import("./college-admin-dashbaord/checklist/checklist.component").then(
            (m) => m.ChecklistComponent,
          ),
      },

      {
        path: "checklist/checklist-form",
        canActivate: [featureGuard],
        data: { feature: "Checklist Form" },
        loadComponent: () =>
          import("./college-admin-dashbaord/checklist/checklist-form/checklist-form.component").then(
            (m) => m.ChecklistFormComponent,
          ),
      },

      {
        path: "college-profile",
        canActivate: [featureGuard],
        data: { feature: "College Profile" },
        loadComponent: () =>
          import("./college-admin-dashbaord/college-profile/college-profile.component").then(
            (m) => m.CollegeProfileComponent,
          ),
      },

      {
        path: "checklist-form",
        canActivate: [featureGuard],
        data: { feature: "Checklist Form" },
        loadComponent: () =>
          import("./college-admin-dashbaord/checklist-form/checklist-form.component").then(
            (m) => m.ChecklistFormComponent,
          ),
      },

      {
        path: "completion",
        canActivate: [featureGuard],
        data: { feature: "Completion" },
        loadComponent: () =>
          import("./college-admin-dashbaord/completion/completion.component").then(
            (m) => m.CompletionComponent,
          ),
      },

      {
        path: "employment-status",
        canActivate: [featureGuard],
        data: { feature: "Employment" },
        loadComponent: () =>
          import("./college-admin-dashbaord/employment-status/employment-status.component").then(
            (m) => m.EmploymentStatusComponent,
          ),
      },

      {
        path: "message-panel",
        canActivate: [featureGuard],
        data: { feature: "Message Panel" },
        loadComponent: () =>
          import("./college-admin-dashbaord/message-panel/message-panel.component").then(
            (m) => m.MessagePanelComponent,
          ),
      },

      {
        path: "tuition-fees",
        canActivate: [featureGuard],
        data: { feature: "Tuition & Fees" },
        loadComponent: () =>
          import("./college-admin-dashbaord/tuition-fees/tuition-fees.component").then(
            (m) => m.TuitionFeesComponent,
          ),
      },
      {
        path: "email-notifications",
        loadComponent: () =>
          import("./college-admin-dashbaord/notification/notification.component").then(
            (m) => m.NotificationComponent,
          ),
      },
      {
        path: "callpad",
        canActivate: [featureGuard],
        data: { feature: "Callpad" },
        loadComponent: () =>
          import("./college-admin-dashbaord/call-pad/call-pad.component").then(
            (m) => m.CallPadComponent,
          ),
      },
      {
        path: "related-calls/:id",
        loadComponent: () =>
          import("./college-admin-dashbaord/call-pad/related-call/related-call.component").then(
            (m) => m.RelatedCallComponent,
          ),
      },

      {
        path: "discount-codes",
        canActivate: [featureGuard],
        data: { feature: "Discount Codes" },
        loadComponent: () =>
          import("./college-admin-dashbaord/discount/discount.component").then(
            (m) => m.DiscountComponent,
          ),
      },

      {
        path: "end-of-program",
        canActivate: [featureGuard],
        data: { feature: "End Of Program" },
        loadComponent: () =>
          import("./college-admin-dashbaord/end-of-program/end-of-program.component").then(
            (m) => m.EndOfProgramComponent,
          ),
      },

      {
        path: "payment-overview",
        canActivate: [featureGuard],
        data: { feature: "Payment Overview" },
        loadComponent: () =>
          import("./college-admin-dashbaord/payment-overview/payment-overview.component").then(
            (m) => m.PaymentOverviewComponent,
          ),
      },

      {
        path: "payment-settings",
        canActivate: [featureGuard],
        data: { feature: "Payment Settings" },
        loadComponent: () =>
          import("./college-admin-dashbaord/payment-settings/payment-settings.component").then(
            (m) => m.PaymentSettingsComponent,
          ),
      },
      {
        path: "payment-options",
        loadComponent: () =>
          import("./college-admin-dashbaord/payment-options/payment-options.component").then(
            (m) => m.PaymentOptionsComponent,
          ),
      },
      {
        path: "payment-summary",
        loadComponent: () =>
          import("./college-admin-dashbaord/payment-summary/payment-summary.component").then(
            (m) => m.PaymentSummaryComponent,
          ),
      },

      {
        path: "transcript",
        canActivate: [featureGuard],
        data: { feature: "Transcripts" },
        loadComponent: () =>
          import("./college-admin-dashbaord/transcript/transcript.component").then(
            (m) => m.TranscriptComponent,
          ),
      },

      {
        path: "college-template",
        canActivate: [featureGuard],
        data: { feature: "Templates" },
        loadComponent: () =>
          import("./college-admin-dashbaord/college-template/college-template.component").then(
            (m) => m.CollegeTemplateComponent,
          ),
      },

      {
        path: "payment-schedule",
        canActivate: [featureGuard],
        data: { feature: "Payment Schedule" },
        loadComponent: () =>
          import("./college-admin-dashbaord/payment-schedule/payment-schedule.component").then(
            (m) => m.PaymentScheduleComponent,
          ),
      },

      {
        path: "application-report",
        canActivate: [featureGuard],
        data: { feature: "Application Report" },
        loadComponent: () =>
          import("./college-admin-dashbaord/reports/application-report/application-report.component").then(
            (m) => m.ApplicationReportComponent,
          ),
      },

      {
        path: "payments-report",
        canActivate: [featureGuard],
        data: { feature: "Payment Report" },
        loadComponent: () =>
          import("./college-admin-dashbaord/reports/payments-report/payments-report.component").then(
            (m) => m.PaymentsReportComponent,
          ),
      },

      {
        path: "revenue-report",
        canActivate: [featureGuard],
        data: { feature: "Revenue Report" },
        loadComponent: () =>
          import("./college-admin-dashbaord/reports/renenue-report/renenue-report.component").then(
            (m) => m.RenenueReportComponent,
          ),
      },
      {
        path: "employment-status-report",
        canActivate: [featureGuard],
        data: { feature: "Employment Status Report" },
        loadComponent: () =>
          import("./college-admin-dashbaord/reports/employment-status-report/employment-status-report.component").then(
            (m) => m.EmploymentStatusReportComponent,
          ),
      },
      {
        path: "permissions/role-permissions",
        loadComponent: () =>
          import("./college-admin-dashbaord/permissions/role-permissions/role-permissions.component").then(
            (m) => m.RolePermissionsComponent,
          ),
      },

      {
        path: "permissions/user-permissions",
        loadComponent: () =>
          import("./college-admin-dashbaord/permissions/user-permissions/user-permissions.component").then(
            (m) => m.UserPermissionsComponent,
          ),
      },

      {
        path: "subscription",
        canActivate: [featureGuard],
        data: { feature: "Subscription" },
        loadComponent: () =>
          import("./college-admin-dashbaord/subscription/subscription.component").then(
            (m) => m.SubscriptionComponent,
          ),
      },
      {
        path: "pricing-plans",
        loadComponent: () =>
          import("./college-admin-dashbaord/pricing-plans/pricing-plans.component").then(
            (m) => m.PricingPlansComponent,
          ),
      },
      {
        path: "invoices",
        canActivate: [featureGuard],
        data: { feature: "Invoices" },
        loadComponent: () =>
          import("./college-admin-dashbaord/invoices/invoices.component").then(
            (m) => m.InvoicesComponent,
          ),
      },
      {
        path: "enrollment-form",
        canActivate: [AuthGuard, SessionLockGuard],
        data: { userTypes: ENROLLMENT_SHARED_USER_TYPES },
        loadComponent: () =>
          import("./student-dashboard/enrollment/enrollment-form/enrollment-form.component").then(
            (m) => m.EnrollmentFormComponent,
          ),
      },

      {
        path: "required-forms",
        canActivate: [featureGuard],
        data: { feature: "Required Forms" },
        loadComponent: () =>
          import("./college-admin-dashbaord/required-forms/required-forms.component").then(
            (m) => m.RequiredFormsComponent,
          ),
      },
      {
        path: "form-submissions",
        canActivate: [featureGuard],
        data: { feature: "Form Submissions" },
        loadComponent: () =>
          import("./college-admin-dashbaord/form-submission/form-submission.component").then(
            (m) => m.FormSubmissionComponent,
          ),
      },
      {
        path: "student-resources",
        canActivate: [featureGuard],
        data: { feature: "Student Resources" },
        loadComponent: () =>
          import("./college-admin-dashbaord/student-resources/student-resources.component").then(
            (m) => m.StudentResourcesComponent,
          ),
      },
      {
        path: "feature-locked",
        loadComponent: () =>
          import("./common/components/feature-locked/feature-locked.component").then(
            (m) => m.FeatureLockedComponent,
          ),
      },
      {
        path: "audit-log",
        loadComponent: () =>
          import("./college-admin-dashbaord/audit-log/audit-log.component").then(
            (m) => m.AuditLogComponent,
          ),
      },

      {
        path: "expenses/expense",
        loadComponent: () =>
          import("./college-admin-dashbaord/expenses/expense/expense.component").then(
            (m) => m.ExpenseComponent,
          ),
      },

      {
        path: "expenses/expense-category",
        loadComponent: () =>
          import("./college-admin-dashbaord/expenses/expense-category/expense-category.component").then(
            (m) => m.ExpenseCategoryComponent,
          ),
      },

      {
        path: "jobs",
        loadComponent: () =>
          import("./college-admin-dashbaord/jobs/jobs.component").then(
            (m) => m.JobsComponent,
          ),
      },
      {
        path: 'mail-usage',
        loadComponent: () => import('./college-admin-dashbaord/mail-usage/mail-usage.component')
          .then((m) => m.MailUsageComponent)
      },

      {
        path: "department",
        loadComponent: () =>
          import("./college-admin-dashbaord/department/department.component").then(
            (m) => m.DepartmentComponent,
          ),
      },
      {
        path: "hired-applicants",
        loadComponent: () =>
          import("./hr-admin-dashboard/hired-applicants/hired-applicants.component").then(
            (m) => m.HiredApplicantsComponent,
          ),
      },
      ...enrollmentFormRoute,
      ...applicationFormRoute,
      ...profileRoute,
      ...settingsRoute,
      ...sharedRoutes,
      ...enrollmentPaymentPageRoute,

      { path: "**", component: NotFoundAdmComponent },
    ],
  },

  {
    path: "admin-dashboard",
    component: MainLayoutComponent,
    canActivate: [AuthGuard, SessionLockGuard],
    data: { userTypes: [0, 2, 3, 5, 6, 7] },
    children: [
      { path: "", redirectTo: "welcome", pathMatch: "full" },
      {
        path: "users",
        loadComponent: () =>
          import("./admin-dashboard/users/users.component").then(
            (m) => m.UsersComponent,
          ),
      },
      {
        path: "programs",
        loadComponent: () =>
          import("./admin-dashboard/programs/programs.component").then(
            (m) => m.ProgramsComponent,
          ),
      },

      {
        path: "fees-components",
        loadComponent: () =>
          import("./admin-dashboard/fee-items/fee-items.component").then(
            (m) => m.FeeItemsComponent,
          ),
      },

      {
        path: "programs",
        loadComponent: () =>
          import("./admin-dashboard/programs/programs.component").then(
            (m) => m.ProgramsComponent,
          ),
      },

      {
        path: "enrollment",
        loadComponent: () =>
          import("./admin-dashboard/enrollment/enrollment.component").then(
            (m) => m.EnrollmentComponent,
          ),
      },

      {
        path: "applications",
        loadComponent: () =>
          import("./admin-dashboard/applications/applications.component").then(
            (m) => m.ApplicationsComponent,
          ),
      },
      {
        path: "applications/applications-approval",
        loadComponent: () =>
          import("./admin-dashboard/approve-application-form/approve-application-form.component").then(
            (m) => m.ApproveApplicationFormComponent,
          ),
      },

      {
        path: "complete-profile",
        loadComponent: () =>
          import("./authentication/college-profile-wizard/college-profile-wizard.component").then(
            (m) => m.CollegeProfileWizardComponent,
          ),
      },

      {
        path: "college-leads",
        loadComponent: () =>
          import("./admin-dashboard/college-leads/college-leads.component").then(
            (m) => m.CollegeLeadsComponent,
          ),
      },

      //tamplate path
      {
        path: "admin-template",
        loadComponent: () =>
          import("./admin-dashboard/template/template.component").then(
            (m) => m.TemplatesComponent,
          ),
      },

      {
        path: "college-management",
        loadComponent: () =>
          import("./admin-dashboard/college-management/college-management.component").then(
            (m) => m.CollegeManagementComponent,
          ),
      },

      {
        path: "program-dates",
        loadComponent: () =>
          import("./admin-dashboard/program-dates/program-dates.component").then(
            (m) => m.ProgramDatesComponent,
          ),
      },

      {
        path: "welcome",
        loadComponent: () =>
          import("./admin-dashboard/welcome/welcome.component").then(
            (m) => m.WelcomeComponent,
          ),
      },
      {
        path: "pricing-plans",
        loadComponent: () =>
          import("./admin-dashboard/pricing-plans/pricing-plans.component").then(
            (m) => m.PricingPlansComponent,
          ),
      },
      {
        path: "schedules",
        loadComponent: () =>
          import("./admin-dashboard/schedule/program-schedule/program-schedule.component").then(
            (m) => m.ProgramScheduleComponent,
          ),
      },
      {
        path: "schedule-type",
        loadComponent: () =>
          import("./admin-dashboard/schedule/schedules-type/schedules-type.component").then(
            (m) => m.SchedulesTypeComponent,
          ),
      },

      {
        path: "message-templates",
        loadComponent: () =>
          import("./admin-dashboard/message-templates/message-templates.component").then(
            (m) => m.MessageTemplatesComponent,
          ),
      },
      {
        path: "clearance",
        loadComponent: () =>
          import("./admin-dashboard/clearance/clearance.component").then(
            (m) => m.ClearanceComponent,
          ),
      },
      // {
      //   path: "clearance/clearance-form",
      //   loadComponent: () =>
      //     import("./admin-dashboard/clearance/clearance-form/clearance-form.component").then(
      //       (m) => m.ClearanceFormComponent,
      //     ),
      // },
      {
        path: "checklist",
        loadComponent: () =>
          import("./admin-dashboard/checklist/checklist.component").then(
            (m) => m.ChecklistComponent,
          ),
      },

      {
        path: "checklist/checklist-form",
        loadComponent: () =>
          import("./admin-dashboard/checklist/checklist-form/checklist-form.component").then(
            (m) => m.ChecklistFormComponent,
          ),
      },

      {
        path: "checklist-form",
        loadComponent: () =>
          import("./admin-dashboard/checklist-form/checklist-form.component").then(
            (m) => m.ChecklistFormComponent,
          ),
      },

      {
        path: "completion",
        loadComponent: () =>
          import("./admin-dashboard/completion/completion.component").then(
            (m) => m.CompletionComponent,
          ),
      },

      {
        path: "employment-status",
        loadComponent: () =>
          import("./admin-dashboard/employment-status/employment-status.component").then(
            (m) => m.EmploymentStatusComponent,
          ),
      },

      {
        path: "message-panel",
        loadComponent: () =>
          import("./admin-dashboard/message-panel/message-panel.component").then(
            (m) => m.MessagePanelComponent,
          ),
      },

      {
        path: "tuition-fees",
        loadComponent: () =>
          import("./admin-dashboard/tuition-fees/tuition-fees.component").then(
            (m) => m.TuitionFeesComponent,
          ),
      },
      {
        path: "email-notifications",
        loadComponent: () =>
          import("./admin-dashboard/notification/notification.component").then(
            (m) => m.NotificationComponent,
          ),
      },
      {
        path: "callpad",
        loadComponent: () =>
          import("./admin-dashboard/call-pad/call-pad.component").then(
            (m) => m.CallPadComponent,
          ),
      },
      {
        path: "related-calls/:id",
        loadComponent: () =>
          import("./admin-dashboard/call-pad/related-call/related-call.component").then(
            (m) => m.RelatedCallComponent,
          ),
      },
      {
        path: "discount-codes",
        loadComponent: () =>
          import("./admin-dashboard/discount/discount.component").then(
            (m) => m.DiscountComponent,
          ),
      },
      {
        path: "payment-overview",
        loadComponent: () =>
          import("./admin-dashboard/payment-overview/payment-overview.component").then(
            (m) => m.PaymentOverviewComponent,
          ),
      },
      {
        path: "payment-settings",
        loadComponent: () =>
          import("./admin-dashboard/payment-settings/payment-settings.component").then(
            (m) => m.PaymentSettingsComponent,
          ),
      },
      {
        path: "payment-options",
        loadComponent: () =>
          import("./admin-dashboard/payment-settings/payment-options/payment-options.component").then(
            (m) => m.PaymentOptionsComponent,
          ),
      },
      {
        path: "payment-summary",
        loadComponent: () =>
          import("./admin-dashboard/payment-summary/payment-summary.component").then(
            (m) => m.PaymentSummaryComponent,
          ),
      },

      {
        path: "transcript",
        loadComponent: () =>
          import("./admin-dashboard/transcript/transcript.component").then(
            (m) => m.TranscriptComponent,
          ),
      },

      {
        path: "payment-schedule",
        loadComponent: () =>
          import("./admin-dashboard/payment-schedule/payment-schedule.component").then(
            (m) => m.PaymentScheduleComponent,
          ),
      },

      {
        path: "application-report",
        loadComponent: () =>
          import("./admin-dashboard/reports/application-report/application-report.component").then(
            (m) => m.ApplicationReportComponent,
          ),
      },

      {
        path: "payments-report",
        loadComponent: () =>
          import("./admin-dashboard/reports/payments-report/payments-report.component").then(
            (m) => m.PaymentsReportComponent,
          ),
      },

      {
        path: "revenue-report",
        loadComponent: () =>
          import("./admin-dashboard/reports/renenue-report/renenue-report.component").then(
            (m) => m.RenenueReportComponent,
          ),
      },
      {
        path: "employment-status-report",
        loadComponent: () =>
          import("./admin-dashboard/reports/employment-status-report/employment-status-report.component").then(
            (m) => m.EmploymentStatusReportComponent,
          ),
      },
      {
        path: "subscriptions",
        loadComponent: () =>
          import("./admin-dashboard/subscriptions/subscriptions.component").then(
            (m) => m.SubscriptionsComponent,
          ),
      },

      {
        path: "permissions/role-permissions",
        loadComponent: () =>
          import("./admin-dashboard/permissions/role-permissions/role-permissions.component").then(
            (m) => m.RolePermissionsComponent,
          ),
      },

      {
        path: "permissions/user-permissions",
        loadComponent: () =>
          import("./admin-dashboard/permissions/user-permissions/user-permissions.component").then(
            (m) => m.UserPermissionsComponent,
          ),
      },

      {
        path: "pricing-plans",
        loadComponent: () =>
          import("./admin-dashboard/pricing-plans/pricing-plans.component").then(
            (m) => m.PricingPlansComponent,
          ),
      },

      {
        path: "invoice",
        loadComponent: () =>
          import("./admin-dashboard/invoice/invoice.component").then(
            (m) => m.InvoiceComponent,
          ),
      },
      ...enrollmentFormRoute,
      ...applicationFormRoute,
      ...profileRoute,
      ...settingsRoute,
      ...sharedRoutes,
      ...enrollmentPaymentPageRoute,

      { path: "**", component: NotFoundAdmComponent },
    ],
  },

  {
    path: "student-dashboard",
    component: StudentDashLayoutComponent,
    canActivate: [AuthGuard, SessionLockGuard],
    data: { userTypes: [1] },
    children: [
      { path: "", redirectTo: "welcome", pathMatch: "full" },
      {
        path: "welcome",
        loadComponent: () =>
          import("./student-dashboard/welcome/welcome.component").then(
            (m) => m.WelcomeComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "dashboard" },
      },
      {
        path: "applications",
        loadComponent: () =>
          import("./common/components/applications-table/applications-table.component").then(
            (m) => m.ApplicationsTableComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "applications" },
      },

      {
        path: "enrollment-table",
        loadComponent: () =>
          import("./student-dashboard/enrollment/enrollment-table/enrollment-table.component").then(
            (m) => m.EnrollmentTableComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "enrollment-table" },
      },

      {
        path: "enrollment-form",
        loadComponent: () =>
          import("./student-dashboard/enrollment/enrollment-form/enrollment-form.component").then(
            (m) => m.EnrollmentFormComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "enrollment-form" },
      },
      {
        path: "checklist",
        loadComponent: () =>
          import("./student-dashboard/checklist/checklist.component").then(
            (m) => m.ChecklistComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "checklist-form" },
      },

      {
        path: "checklist/checklist-form",
        loadComponent: () =>
          import("./student-dashboard/checklist/checklist-form/checklist-form.component").then(
            (m) => m.ChecklistFormComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "checklist-form" },
      },
      {
        path: "payment-summary",
        loadComponent: () =>
          import("./student-dashboard/payment-summary/payment-summary.component").then(
            (m) => m.PaymentSummaryComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "payment-history" },
      },
      {
        path: "payment-schedule",
        loadComponent: () =>
          import("./student-dashboard/payment-schedule/payment-schedule.component").then(
            (m) => m.PaymentScheduleComponent,
          ),

        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "payment-schedule" },
      },
      {
        path: "discount-codes",
        loadComponent: () =>
          import("./student-dashboard/discount-codes/discount-codes.component").then(
            (m) => m.DiscountCodesComponent,
          ),

        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "discount-codes" },
      },
      // {
      //   path: "enrollment-payment",
      //   loadComponent: () =>
      //     import("./student-dashboard/enrollment/enrollment-payment-page/enrollment-payment-page.component").then(
      //       (m) => m.EnrollmentPaymentPageComponent,
      //     ),
      // },

      {
        path: "application-form",
        loadComponent: () =>
          import("./common/components/applications-stepper/applications-stepper.component").then(
            (m) => m.ApplicationsStepperComponent,
          ),

        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "application-form" },
      },

      {
        path: "payment-result",
        loadComponent: () =>
          import("./student-dashboard/payment-result/payment-result.component").then(
            (m) => m.PaymentResultComponent,
          ),

        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "payment-history" },
      },

      {
        path: "message-panel",
        loadComponent: () =>
          import("./student-dashboard/message-panel/message-panel.component").then(
            (m) => m.MessagePanelComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "messages" },
      },

      {
        path: "account-holds",
        loadComponent: () =>
          import("./student-dashboard/account-holds/account-holds.component").then(
            (m) => m.AccountHoldsComponent,
          ),
      },
      {
        path: "announcements",
        loadComponent: () =>
          import("./student-dashboard/announcements/announcements.component").then(
            (m) => m.AnnouncementsComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "announcements" },
      },

      {
        path: "student-required-forms",
        loadComponent: () =>
          import("./student-dashboard/student-required-forms/student-required-forms.component").then(
            (m) => m.StudentRequiredFormsComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "student-required-forms" },
      },

      {
        path: "student-resource",
        loadComponent: () =>
          import("./student-dashboard/student-resource/student-resource.component").then(
            (m) => m.StudentResourceComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "student-resource" },
      },

      {
        path: "career-opportunity",
        loadComponent: () =>
          import("./student-dashboard/career-opportunity/career-opportunity.component").then(
            (m) => m.CareerOpportunityComponent,
          ),
        canActivate: [HoldRestrictionGuard],
        data: { moduleId: "career-opportunity" },
      },

      {
        path: "career-opportunity/job-details/:id",
        loadComponent: () =>
          import("./student-dashboard/career-opportunity/job-details/job-details.component").then(
            (m) => m.JobDetailsComponent,
          ),
      },
      ...enrollmentFormRoute,
      ...applicationFormRoute,
      ...profileRoute,
      ...settingsRoute,
      ...enrollmentPaymentPageRoute,

      { path: "**", component: NotFoundStudentComponent },
    ],
  },

  ...CheckoutRoute,
  ...PaymentStatusRoute,

  { path: "**", component: NotFoundComponent },

  { path: "starter", component: ApplicationsStepperComponent },
];
